import { render, staticRenderFns } from "./UserDossier.vue?vue&type=template&id=0ec9b642&scoped=true"
import script from "./UserDossier.vue?vue&type=script&lang=js"
export * from "./UserDossier.vue?vue&type=script&lang=js"
import style0 from "./UserDossier.vue?vue&type=style&index=0&id=0ec9b642&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec9b642",
  null
  
)

export default component.exports